import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { getAuth } from "firebase/auth";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const auth = getAuth();
  const [status, setStatus] = useState("Checking payment...");

  useEffect(() => {
    const updateUser = async () => {
      const user = auth.currentUser;
      if (!user) {
        setStatus("Please log in");
        return;
      }

      try {
        // Update user to PRO
        await updateDoc(doc(db, "users", user.uid), {
          isPro: true,
          proSince: new Date(),
          lastPayment: new Date().toISOString(),
        });

        setStatus("✅ Success! You're now a Pro user!");

        // Wait 3 seconds then redirect
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
      } catch (error) {
        console.error("Error:", error);
        setStatus("Payment received! Refreshing your account...");
      }
    };

    updateUser();
  }, [auth.currentUser, navigate]);

  return (
    <div style={{ textAlign: "center", padding: "50px 20px" }}>
      <h1>Payment Complete</h1>
      {/* <p>{status}</p> */}
      <button
        onClick={() => navigate("/dashboard")}
        style={{
          backgroundColor: "#0070f3",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "20px",
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default PaymentSuccess;
